module.exports = __webpack_public_path__ + "media/images/area/icon_weather_9-440041f0ef08486a8b21e8ab61e333cc.png";